import Table from '@/common/components/Table';
import React, { useMemo } from 'react';
import { getRows } from '../../helpers/getRows';
import { getRefundTableHeaders } from '../../constants/refundTableHeaders';

const RefundTable = ({ hook }) => {
	const selectedStatus = hook.selectedStatus?.value;

	const headers = useMemo(() => getRefundTableHeaders(selectedStatus), [selectedStatus]);

	const rows = useMemo(() => {
		if (!hook.refunds?.length) {
			return [];
		}
		return getRows(
			hook.refunds,
			selectedStatus,
			hook.setSelectedRefund,
			hook.handleDownloadPdf,
			hook.loadingFiles,
		);
	}, [hook.refunds, hook.loadingFiles, selectedStatus]);

	return <Table className="styled-table" headers={headers} raws={rows} />;
};

export default RefundTable;
